export const CheckPositionChangeInitial = {
  status: false,
  reasonForRejection: "",
};
